import Vue from 'vue'
import VueRouter from 'vue-router'
import pcpage from '@/components/pc/pcpage'
import africa_teacher_classlive from "@/components/pc/africa_teacher_classlive.vue"
import guide from "@/components/pc/guide.vue"
import chinesebridge from "@/components/pc/chinesebridge.vue"
import classlive from "@/components/pc/classlive.vue";
import chineseplus_classlive from "@/components/pc/chineseplus_classlive.vue";
import indonesian_leadership_training from "@/components/pc/indonesian_leadership_training";
import epidemic_training_public_teachers from "@/components/pc/epidemic_training_public_teachers";
import public_teacher_policy_interpretation from "@/components/pc/public_teacher_policy_interpretation";
// import clec_chinese_smart_classroom from "@/components/pc/clec_chinese_smart_classroom";
// import confirm_smart_classroom_apply from "@/components/pc/confirm_smart_classroom_apply";
// import clec_partner from "@/components/pc/clec_partner";
import learn_chinese_language from "@/components/pc/learn_chinese_language";
import chineseplus_live2022 from "@/components/pc/chineseplus_live2022.vue";
import chineseplus_live2023 from "@/components/pc/chineseplus_live2023.vue";
import pakistan_class_live from "@/components/pc/pakistan_class_live.vue";
import indonesian_native_teacher_classA from "@/components/pc/indonesian_native_teacher_classA.vue";
import indonesian_native_teacher_classB from "@/components/pc/indonesian_native_teacher_classB.vue";
import indonesian_leadership_classC from "@/components/pc/indonesian_leadership_classC.vue";
import indonesian_leadership_classD from "@/components/pc/indonesian_leadership_classD.vue";
import storyofchina from "@/components/pc/storyofchina.vue";
import russia_business from "@/components/pc/russia_business.vue";
import cis_business from "@/components/pc/cis_business.vue";
import cis_business2024 from "@/components/pc/cis_business2024.vue";
import chinese_Culture_Video_Exhibition from "@/components/pc/chinese_Culture_Video_Exhibition.vue";
import chinese_Culture_Video_Exhibition_2024 from "@/components/pc/chinese_Culture_Video_Exhibition_2024.vue";
import chinese_Culture_Video_Exhibition_2025 from "@/components/pc/chinese_Culture_Video_Exhibition_2025.vue";
import chinese_Culture_Video_Exhibition_2025_detail from "@/components/pc/chinese_Culture_Video_Exhibition_2025_detail.vue";
import chinese_Culture_Video_Exhibition_2026 from "@/components/pc/chinese_Culture_Video_Exhibition_2026.vue";
import chinese_Culture_Video_Exhibition_2026_detail from "@/components/pc/chinese_Culture_Video_Exhibition_2026_detail.vue";
import harmonious_Video_Exhibition_2025 from "@/components/pc/harmonious_Video_Exhibition_2025.vue";
import harmonious_Video_Exhibition_2025_detail from "@/components/pc/harmonious_Video_Exhibition_2025_detail.vue";

// import explanation_of_teacher_benefits from "@/components/pc/explanation_of_teacher_benefits.vue";
import international_Communication_Capacity_Building from "@/components/pc/international_Communication_Capacity_Building.vue";

import m_page from '@/components/m/m_page'
import m_mainpage from '@/components/m/m_mainpage'
import m_guide from "@/components/m/m_guide"
import m_guidedetail from "@/components/m/m_guidedetail"
import m_chinesebridge from "@/components/m/m_chinesebridge"
import m_classlive from "@/components/m/m_classlive";
import m_chineseplus_classlive from "@/components/m/m_chineseplus_classlive";
import m_indonesian_leadership_training from "@/components/m/m_indonesian_leadership_training";
import m_indonesian_leadership_training_detail from "@/components/m/m_indonesian_leadership_training_detail";
import m_epidemic_training_public_teachers from "@/components/m/m_epidemic_training_public_teachers";
import m_public_teacher_policy_interpretation from "@/components/m/m_public_teacher_policy_interpretation";
// import m_clec_chinese_smart_classroom from "@/components/m/m_clec_chinese_smart_classroom";
// import m_clec_partner from "@/components/m/m_clec_partner";
import m_learn_chinese_language from "@/components/m/m_learn_chinese_language";
import m_chineseplus_live2022 from "@/components/m/m_chineseplus_live2022.vue";
import m_chineseplus_live2023 from "@/components/m/m_chineseplus_live2023.vue";
import m_pakistan_class_live from "@/components/m/m_pakistan_class_live.vue";
import m_indonesian_native_teacher_classA from "@/components/m/m_indonesian_native_teacher_classA.vue";
import m_indonesian_native_teacher_classB from "@/components/m/m_indonesian_native_teacher_classB.vue";
import m_indonesian_leadership_classC from "@/components/m/m_indonesian_leadership_classC.vue";
import m_indonesian_leadership_classD from "@/components/m/m_indonesian_leadership_classD.vue";
import m_storyofchina from "@/components/m/m_storyofchina.vue";
import m_russia_business from "@/components/m/m_russia_business.vue";
import m_cis_business from "@/components/m/m_cis_business.vue";
import m_cis_business2024 from "@/components/m/m_cis_business2024.vue";
import m_chinese_Culture_Video_Exhibition from "@/components/m/m_chinese_Culture_Video_Exhibition.vue";
import m_chinese_Culture_Video_Exhibition_2024 from "@/components/m/m_chinese_Culture_Video_Exhibition_2024.vue";
import m_chinese_Culture_Video_Exhibition_2025 from "@/components/m/m_chinese_Culture_Video_Exhibition_2025.vue";
import m_chinese_Culture_Video_Exhibition_2025_detail from "@/components/m/m_chinese_Culture_Video_Exhibition_2025_detail.vue";
import m_chinese_Culture_Video_Exhibition_2026 from "@/components/m/m_chinese_Culture_Video_Exhibition_2026.vue";
import m_chinese_Culture_Video_Exhibition_2026_detail from "@/components/m/m_chinese_Culture_Video_Exhibition_2026_detail.vue";
import m_harmonious_Video_Exhibition_2025 from "@/components/m/m_harmonious_Video_Exhibition_2025.vue";
import m_harmonious_Video_Exhibition_2025_detail from "@/components/m/m_harmonious_Video_Exhibition_2025_detail.vue";
// import m_explanation_of_teacher_benefits from "@/components/m/m_explanation_of_teacher_benefits.vue";
import m_international_Communication_Capacity_Building from "@/components/m/m_international_Communication_Capacity_Building.vue";


const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location, onResolve, onReject) {
  if (onResolve || onReject) return originalPush.call(this, location, onResolve, onReject)
  return originalPush.call(this, location).catch(err => err)
}

const originalReplace = VueRouter.prototype.replace
VueRouter.prototype.replace = function repalce(location, onResolve, onReject) {
  if (onResolve || onReject) return originalReplace.call(this, location, onResolve, onReject)
  return originalReplace.call(this, location).catch(err => err)
}

Vue.use(VueRouter)
const router = new VueRouter({
  routes: [
    {
      path: "/",
      redirect: "/pcpage",
    },
    {
      path: "/pcpage",
      redirect: "/pcpage/guide",
      component: pcpage,
      children: [
        {
          path: "guide",
          component: guide,
          children: [],
          meta: {
            title: "中文联盟-使用指南",
          },
        },
        {
          path: "africa_teacher_classlive",
          component: africa_teacher_classlive,
          children: [],
        },
        {
          path: "indonesian_leadership_training",
          component: indonesian_leadership_training,
        },
        {
          path: "epidemic_training_public_teachers",
          component: epidemic_training_public_teachers,
        },
        // {
        //   path: "clec_chinese_smart_classroom",
        //   component: clec_chinese_smart_classroom,
        //   meta: {
        //     title: "中外语言交流合作中心",
        //     ico: "favicon2.ico",
        //     keepAlive: true,
        //   },
        // },
        // {
        //   path: "confirm_smart_classroom_apply",
        //   component: confirm_smart_classroom_apply,
        //   meta: {
        //     title: "中外语言交流合作中心",
        //     ico: "favicon2.ico",
        //     keepAlive: true,
        //   },
        // },
        // {
        //   path: "clec_partner",
        //   component: clec_partner,
        //   meta: {
        //     title: "中外语言交流合作中心",
        //     ico: "favicon2.ico",
        //     keepAlive: true,
        //   },
        // },
        {
          path: "public_teacher_policy_interpretation",
          component: public_teacher_policy_interpretation,
        },
        {
          path: "chinesebridge",
          component: chinesebridge,
          meta: {
            title: "汉语桥团组在线体验平台",
          },
        },
        {
          path: "classlive",
          component: classlive,
          meta: {
            title: "中文联盟",
          },
        },
        {
          path: "chineseplus_classlive",
          component: chineseplus_classlive,
          meta: {
            title: "停课不停学",
          },
        },
        {
          path: "learn_chinese_language",
          component: learn_chinese_language,
          meta: {
            title: "中文联盟",
          },
        },
        {
          path: "chineseplus_live2022",
          component: chineseplus_live2022,
          meta: {
            title: "2022停课不停学",
          },
        },
        {
          path: "chineseplus_live2023",
          component: chineseplus_live2023,
          meta: {
            title: "2023年全球免费中文直播课",
          },
        },
        {
          path: "pakistan_class_live",
          component: pakistan_class_live,
          meta: {
            title: "直播公开课",
          },
        },
        {
          path: "indonesian_native_teacher_classA",
          component: indonesian_native_teacher_classA,
        },
        {
          path: "indonesian_native_teacher_classB",
          component: indonesian_native_teacher_classB,
        },
        {
          path: "indonesian_leadership_classC",
          component: indonesian_leadership_classC,
        },
        {
          path: "indonesian_leadership_classD",
          component: indonesian_leadership_classD,
        },
        {
          path: "storyofchina",
          component: storyofchina,
          meta: {
            title: "中文联盟",
          },
        },
        {
          path: "russia_business",
          component: russia_business,
          meta: {
            title: "2022俄罗斯商务中文人才线上培训专项直播课",
          },
        },
        {
          path: "cis_business",
          component: cis_business,
          meta: {
            title: "2023年独联体地区商务中文人才线上培育专项",
          },
        },
        {
          path: "cis_business2024",
          component: cis_business2024,
          meta: {
            title: "2024年独联体地区商务中文人才线上培育专项",
          },
        },
        // {
        //   path: "cmgp",
        //   component: chinese_Culture_Video_Exhibition,
        //   meta: {
        //     title: "中国文化视频展播季",
        //   },
        // },
        {
          path: "cmgp",
          component: chinese_Culture_Video_Exhibition_2024,
          meta: {
            title: "中国文化视频展播季",
          },
        },
        {
          path: "cmgp2025",
          component: chinese_Culture_Video_Exhibition_2025,
          meta: {
            title: "中国文化视频展播季",
          },
        },
        {
          path: "cmgp2025_detail",
          component: chinese_Culture_Video_Exhibition_2025_detail,
          meta: {
            title: "中国文化视频展播季",
          },
        },
        {
          path: "cmgp2026",
          component: chinese_Culture_Video_Exhibition_2026,
          meta: {
            title: "中国文化视频展播季",
          },
        },
        {
          path: "cmgp2026_detail",
          component: chinese_Culture_Video_Exhibition_2026_detail,
          meta: {
            title: "中国文化视频展播季",
          },
        },
        {
          path: "hm2025",
          component: harmonious_Video_Exhibition_2025,
          meta: {
            title: "和合之美视频展播季",
          },
        },
        {
          path: "hm2025_detail",
          component: harmonious_Video_Exhibition_2025_detail,
          meta: {
            title: "和合之美视频展播季",
          },
        },
        // {
        //   path: "explanation_of_teacher_benefits",
        //   component: explanation_of_teacher_benefits,
        // },
        {
          path: "iccb",
          component: international_Communication_Capacity_Building,
          meta: {
            title: "“国际传播能力建设”在线培训课程",
          },
        },
      ],
    },
    {
      path: "/m_page",
      redirect: "/m_page/m_mainpage",
      component: m_page,
      children: [
        {
          path: "m_mainpage",
          component: m_mainpage,
        },
        {
          path: "m_guide",
          component: m_guide,
        },
        {
          path: "m_guidedetail",
          component: m_guidedetail,
        },
        {
          path: "m_chinesebridge",
          component: m_chinesebridge,
          meta: {
            title: "汉语桥团组在线体验平台",
          },
        },
        {
          path: "m_classlive",
          component: m_classlive,
        },
        {
          path: "m_chineseplus_classlive",
          component: m_chineseplus_classlive,
        },
        {
          path: "m_indonesian_leadership_training",
          component: m_indonesian_leadership_training,
        },
        {
          path: "m_indonesian_leadership_training_detail",
          component: m_indonesian_leadership_training_detail,
        },
        {
          path: "m_epidemic_training_public_teachers",
          component: m_epidemic_training_public_teachers,
        },
        // {
        //   path: "m_clec_chinese_smart_classroom",
        //   component: m_clec_chinese_smart_classroom,
        //   meta: {
        //     title: "中外语言交流合作中心",
        //     ico: "favicon2.ico",
        //     keepAlive: true,
        //   },
        // },
        // {
        //   path: "m_clec_partner",
        //   component: m_clec_partner,
        //   meta: {
        //     title: "中外语言交流合作中心",
        //     ico: "favicon2.ico",
        //     keepAlive: true,
        //   },
        // },
        {
          path: "m_public_teacher_policy_interpretation",
          component: m_public_teacher_policy_interpretation,
        },
        {
          path: "m_learn_chinese_language",
          component: m_learn_chinese_language,
          meta: {
            title: "中文联盟",
          },
        },
        {
          path: "m_chineseplus_live2022",
          component: m_chineseplus_live2022,
          meta: {
            title: "2022停课不停学",
          },
        },
        {
          path: "m_chineseplus_live2023",
          component: m_chineseplus_live2023,
          meta: {
            title: "2023年全球免费中文直播课",
          },
        },
        {
          path: "m_pakistan_class_live",
          component: m_pakistan_class_live,
          meta: {
            title: "直播公开课",
          },
        },
        {
          path: "m_indonesian_native_teacher_classA",
          component: m_indonesian_native_teacher_classA,
        },
        {
          path: "m_indonesian_native_teacher_classB",
          component: m_indonesian_native_teacher_classB,
        },
        {
          path: "m_indonesian_leadership_classC",
          component: m_indonesian_leadership_classC,
        },
        {
          path: "m_indonesian_leadership_classD",
          component: m_indonesian_leadership_classD,
        },
        {
          path: "m_storyofchina",
          component: m_storyofchina,
        },
        {
          path: "m_russia_business",
          component: m_russia_business,
          meta: {
            title: "2022俄罗斯商务中文人才线上培训专项直播课",
          },
        },
        {
          path: "m_cis_business",
          component: m_cis_business,
          meta: {
            title: "2023年独联体地区商务中文人才线上培育专项",
          },
        },
        {
          path: "m_cis_business2024",
          component: m_cis_business2024,
          meta: {
            title: "2024年独联体地区商务中文人才线上培育专项",
          },
        },
        // {
        //   path: "m_cmgp",
        //   component: m_chinese_Culture_Video_Exhibition,
        //   meta: {
        //     title: "中国文化视频展播季",
        //   },
        // },
        {
          path: "m_cmgp",
          component: m_chinese_Culture_Video_Exhibition_2024,
          meta: {
            title: "中国文化视频展播季",
          },
        },
        // {
        //   path: "m_cmgp2025",
        //   component: m_chinese_Culture_Video_Exhibition_2025,
        //   meta: {
        //     title: "中国文化视频展播季",
        //   },
        // },
        // {
        //   path: "m_cmgp2025_detail",
        //   component: m_chinese_Culture_Video_Exhibition_2025_detail,
        //   meta: {
        //     title: "中国文化视频展播季",
        //   },
        // },
        {
          path: "m_cmgp2026",
          component: m_chinese_Culture_Video_Exhibition_2026,
          meta: {
            title: "中国文化视频展播季",
          },
        },
        {
          path: "m_cmgp2026_detail",
          component: m_chinese_Culture_Video_Exhibition_2026_detail,
          meta: {
            title: "中国文化视频展播季",
          },
        },
        {
          path: "m_hm2025",
          component: m_harmonious_Video_Exhibition_2025,
          meta: {
            title: "和合之美视频展播季",
          },
        },
        {
          path: "m_hm2025_detail",
          component: m_harmonious_Video_Exhibition_2025_detail,
          meta: {
            title: "和合之美视频展播季",
          },
        },


        // {
        //   path: "m_explanation_of_teacher_benefits",
        //   component: m_explanation_of_teacher_benefits,
        // },
        {
          path: "m_iccb",
          component: m_international_Communication_Capacity_Building,
          meta: {
            title: "“国际传播能力建设”在线培训课程",
          },
        },
      ],
    },
  ],
});
router.beforeEach((to, from, next) => {
  setTimeout(() => {
    if (window.gtag) {
      window.gtag('config', 'G-BXCCS3YN86', { 'page_path': to.fullPath });
    }
  }, 500);

  var link = document.querySelector("link[rel*='icon']") || document.createElement('link');
  link.rel = 'icon';
  link.href = to.meta.ico || 'favicon.ico';
  document.getElementsByTagName('head')[0].appendChild(link);
  /* 路由发生变化修改页面title */
  if (to.meta.title) {
    document.title = to.meta.title;
    next();
  } else {
    document.title = '中文联盟';
    next();
  }
});


export default router